import React from 'react';
import { Button } from '@/components/ui/button';

interface HealthStatusFilterProps {
  healthFilters: Set<string>;
  onFilterChange: (filters: Set<string>) => void;
}

const statusOptions = [
  { value: 'critical', label: 'Critical', color: 'bg-red-600', textColor: 'text-red-600', borderColor: 'border-red-600' },
  { value: 'alarm', label: 'Alarm', color: 'bg-orange-500', textColor: 'text-orange-500', borderColor: 'border-orange-500' },
  { value: 'monitor', label: 'Monitor', color: 'bg-yellow-500', textColor: 'text-yellow-500', borderColor: 'border-yellow-500' },
  { value: 'healthy', label: 'Healthy', color: 'bg-green-600', textColor: 'text-green-600', borderColor: 'border-green-600' }
];

export function HealthStatusFilter({ healthFilters, onFilterChange }: HealthStatusFilterProps) {
  const toggleFilter = (status: string) => {
    const newFilters = new Set(healthFilters);
    if (newFilters.has(status)) {
      // Only delete if it's not the last filter
      if (newFilters.size > 1) {
        newFilters.delete(status);
      }
    } else {
      newFilters.add(status);
    }
    onFilterChange(newFilters);
  };

  return (
    <div className="flex items-center gap-1">
      {statusOptions.map(status => {
        const isActive = healthFilters.has(status.value);
        return (
          <button
            key={status.value}
            onClick={() => toggleFilter(status.value)}
            className={`
              h-6 px-3 rounded-full text-xs font-medium transition-all
              ${isActive 
                ? `${status.color} text-white shadow-sm` 
                : `bg-gray-100 text-gray-600 hover:bg-gray-200`
              }
            `}
          >
            {status.label}
          </button>
        );
      })}
    </div>
  );
}